// Front/src/utils/generateClientJson.js

export const generateClientJson = (formData, userId) => {
    return {
      id: formData.clientId,
      Name: formData.name,
      Address: formData.address,
      NameEng: formData.nameEng,
      AddressEng: formData.addressEng,
      Phone: formData.phone,
      Fax: formData.fax,
      Email: formData.email,
      Department: {
        Name: formData.departmentName,
        Person: formData.departmentPerson
      },
      ContactPerson: {
        Name: formData.contactName,
        NameEng: formData.contactNameEng,
        Email: formData.contactEmail,
        Phone: formData.contactPhone
      },
      IsActive: true,
      PartitionKey: "Client",
      AddedBy: {
        ApiUserId: userId,
        Date: new Date().toISOString()
      }
    };
  };
  